const l = "styles-module__flex___E0trh", e = {
  flex: l,
  "flex--gap-small": "styles-module__flex--gap-small___MU8H2",
  "flex--gap-medium": "styles-module__flex--gap-medium___Nu7Ep",
  "flex--gap-large": "styles-module__flex--gap-large___XsxcQ",
  "flex--gap-x-large": "styles-module__flex--gap-x-large___JCgLG"
};
export {
  e as default,
  l as flex
};
